import { resolveGatewayBaseUrl } from "../../runtime/gatewayEnv";
import { resolveThisAppPublicUrl } from "../../utils/matchesAssignedApplicationOrigin";

function gatewayLoginUrl(): string {
  const fromEnv = (process.env.REACT_APP_LOGIN_URL ?? "").trim();
  if (fromEnv) return fromEnv;
  return `${resolveGatewayBaseUrl({ allowLocalFallback: true })}/login`;
}

export function readThisAppLoginContext(): {
  url: string;
  name: string;
  keycloakClientId: string;
  applicationId: string;
} {
  const url = resolveThisAppPublicUrl();
  const name = (
    process.env.REACT_APP_APPLICATION_NAME ??
    process.env.REACT_APP_KEYCLOAK_CLIENT_ID ??
    "Surveillance"
  ).trim();
  const keycloakClientId = (process.env.REACT_APP_KEYCLOAK_CLIENT_ID ?? "").trim();
  const applicationId = (process.env.REACT_APP_APPLICATION_ID ?? "").trim();
  return { url, name, keycloakClientId, applicationId };
}

export function buildGatewayLoginUrlWithAppContext(options?: {
  forceLogin?: boolean;
}): string {
  const login = new URL(gatewayLoginUrl());
  const ctx = readThisAppLoginContext();
  login.searchParams.set("url", ctx.url);
  if (ctx.name) login.searchParams.set("name", ctx.name);
  if (ctx.keycloakClientId) {
    login.searchParams.set("keycloakClientId", ctx.keycloakClientId);
  }
  if (ctx.applicationId) {
    login.searchParams.set("applicationId", ctx.applicationId);
  }
  if (options?.forceLogin) {
    login.searchParams.set("prompt", "login");
  }
  return login.toString();
}
